import { PageReducerType } from "./types";

export const setActivePage = (
  active: PageReducerType["active"],
  state: PageReducerType,
): PageReducerType => ({ ...state, active });

export const setLoading = (
  loading: PageReducerType["loading"],
  state: PageReducerType,
): PageReducerType => ({ ...state, loading });
